module.exports = __webpack_public_path__ + "img/f8f1ca7.png";